var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgJava = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 22,
    viewBox: "0 0 37 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16833 3.5C2.39431 3.5 0.973684 4.94367 0.973684 6.70259V15.2974C0.973684 17.0563 2.39431 18.5 4.16833 18.5H32.8317C34.6057 18.5 36.0263 17.0563 36.0263 15.2974V6.70259C36.0263 4.94368 34.6057 3.5 32.8317 3.5H4.16833ZM0 6.70259C0 4.37174 1.87589 2.5 4.16833 2.5H32.8317C35.1241 2.5 37 4.37174 37 6.70259V15.2974C37 17.6283 35.1241 19.5 32.8317 19.5H4.16833C1.87589 19.5 0 17.6283 0 15.2974V6.70259Z",
    fill: "#FF3E4C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4243 7.5V11.8938C10.4243 12.5676 10.238 13.0853 9.86533 13.4511C9.6585 13.6397 9.41531 13.7851 9.15026 13.8789C8.88521 13.9726 8.60373 14.0126 8.32266 13.9965C8.01398 14.0125 7.70516 13.968 7.41399 13.8656C7.12282 13.7631 6.85507 13.6048 6.62617 13.3997C6.208 13.004 6 12.4307 6 11.6884H7.55782C7.55782 12.2902 7.78822 12.5911 8.249 12.5911C8.64767 12.5911 8.847 12.3601 8.847 11.8981V7.50428L10.4243 7.5Z",
    fill: "#FF3E4C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0586 12.7579H15.5005L15.8991 13.9323H17.5761L15.1928 7.54488H13.3771L10.9938 13.9323H12.6535L13.0586 12.7579ZM14.285 9.21126L15.0953 11.575H13.4638L14.285 9.21126Z",
    fill: "#FF3E4C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4093 7.5L21.0018 12.3409L22.5965 7.5H24.2843L22.0158 13.9324H19.9792L17.7237 7.5H19.4093Z",
    fill: "#FF3E4C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4857 12.7579H28.9276L29.3263 13.9323H31.0033L28.6199 7.54488H26.8042L24.4209 13.9323H26.0806L26.4857 12.7579ZM27.7121 9.21126L28.5224 11.575H26.8909L27.7121 9.21126Z",
    fill: "#FF3E4C"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgJava);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/java.bff78528fbee0b14aede446f8d092f79.svg";